import { css } from '@/styled-system/css';
import type { SystemStyleObject } from '@/styled-system/types';

export const sidebarAttachmentCardStyles = css.raw({
  alignItems: 'center',
  border: 'solid',
  borderColor: 'border.muted',
  borderWidth: '1px',
  display: 'flex',
  paddingBlock: 'tight',
  paddingLeft: 'default',
  paddingRight: 'tighter',
  alignSelf: 'stretch',
  borderRadius: '300',
});

export const getChatBubbleBorderRadius = (isMessageOwner: boolean): SystemStyleObject => ({
  borderBottomRightRadius: isMessageOwner ? '100' : '500',
  borderBottomLeftRadius: isMessageOwner ? '500' : '100',
});

const messageOwnerAttachmentCardStyles = css.raw({
  alignItems: 'center',
  border: 'solid',
  borderColor: 'border.muted',
  borderWidth: '1px',
  display: 'flex',
  paddingBlock: 'tight',
  paddingLeft: 'default',
  paddingRight: 'tighter',
  borderRadius: '500',
  marginBottom: 'tighter',
  borderBottomRightRadius: '100',
  borderBottomLeftRadius: '500',
});

const messageNonOwnerAttachmentCardStyles = css.raw({
  alignItems: 'center',
  border: 'solid',
  borderColor: 'border.muted',
  borderWidth: '1px',
  display: 'flex',
  paddingBlock: 'tight',
  paddingLeft: 'default',
  paddingRight: 'tighter',
  borderRadius: '500',
  marginBottom: 'tighter',
  borderBottomRightRadius: '500',
  borderBottomLeftRadius: '100',
});

export function getAttachmentCardStyles(variant: 'sidebar' | 'message', isMessageOwner: boolean): SystemStyleObject {
  if (variant === 'sidebar') {
    return sidebarAttachmentCardStyles;
  }

  return isMessageOwner ? messageOwnerAttachmentCardStyles : messageNonOwnerAttachmentCardStyles;
}
